<template>
    <div>
        <breadcrumb :routerList="[{to:'/dingd/material/inland',title:'订单管理'},{title:'内销订单'}]" style="width:100%"/>


        <div class="h-pieceIn2 icon">
            <div class="h-pieceCon2" style="width:100%;padding:20px 10px;background:#fcfcfc;border:1px solid #ccc;">
                <div class="stepBox">
                    <div class="leftstep" :class="{'leftstep1':isA}">下单</div>
                    <div class="rightstep" :class="{'rightstep1':isB}">
                        <div class="readiu" :class="{'readiu1':isC}">
                            <img src="../../../assets/images/checksuccess.png" alt="">
                        </div>
                    </div>
                    <div class="leftstep">订单审核</div>
                    <div class="fukaun">
                        <div class="color">
                            <!-- <img src="../../../assets/images/checksuccess.png" alt="" class="bac-color">                             -->
                        </div>
                    </div>
                    <div class="fuwu">订单付款</div>
                    <div class="fukaun">
                        <div class="color">
                            <!-- <img src="../../../assets/images/checksuccess.png" alt="" > -->
                        </div>
                    </div>
                    <div class="fuwu">物流发货</div>
                    <div class="fukaun">
                        <div class="color">
                            <!-- <img src="../../../assets/images/checksuccess.png" alt="" > -->
                        </div>
                    </div>
                    <div class="fuwu">售后服务</div>
                </div>
            </div>
        </div>


        <div class="h-piece">
            <div class="h-pieceIn2">
                <div class="h-pieceTitle2 name">
                    <h1>项目信息</h1>
                </div>
                <div class="h-pieceCon2">
                    <div class="h-formLine neixiao">
                        <el-form :model="formLabelAlign" label-position="right" :inline="true"
                                 class="demo-ruleForm h-formbLine inputO">
                            <el-form-item label="项目名称" class="h-elformWrap-2">
                                <el-input v-model="projectFname" placeholder="自带出"
                                          class="zidaoO" readonly></el-input>
                            </el-form-item>

                            <el-form-item label="主合同编号" class="h-elformWrap-2 ">
                                <el-input v-model="orderMainContract" placeholder="自带出" readonly></el-input>
                            </el-form-item>
                            <el-form-item label="分合同编号" class="h-elformWrap-2">
                                <el-input v-model="orderSubContract" placeholder="自带出" readonly></el-input>
                            </el-form-item>

                            <div class="xiangmu">
                                <div class="h-pieceTitle2">
                                    <h1>订单信息</h1>
                                </div>

                                <el-form-item label="销售区域" class="h-elformWrap-2">
                                    <brselect category="xiaoshou_quyu" :v="formInline.orderCategory"
                                              v-model="formInline.orderCategory" disabled></brselect>

                                    <!--                                    <el-input v-model="formInline.orderCategory" placeholder="自带出"-->
                                    <!--                                              class="zidaoO" readonly>-->

                                    <!--                                        <template slot-scope="scope">-->
                                    <!--                                            <dictname category="shifou_keyong"  :v="scope.row.orderCategory"/>-->
                                    <!--                                        </template>-->
                                    <!--                                    </el-input>-->
                                </el-form-item>
                                <el-form-item label="销售组织编码" class="h-elformWrap-2">
                                    <brselect style="width: 256px" category="xiaoshou_zuzhi" :v="formInline.spare8"
                                              v-model="formInline.spare8" disabled></brselect>
                                </el-form-item>

                                <el-form-item label="分销渠道" class="h-elformWrap-2">
                                    <brselect style="width: 150px" category="fenxiao_qudao"
                                              :v="formInline.disChannelCode"
                                              v-model="formInline.disChannelCode" disabled></brselect>
                                </el-form-item>

                                <el-form-item label="二级分销渠道" class="h-elformWrap-2" v-if="yincang">
                                    <brselect style="width: 150px" category="z1_xuanxiang" :v="formInline.zCode"
                                              v-model="formInline.zCode" disabled></brselect>
                                </el-form-item>

                            </div>
                        </el-form>
                    </div>
                </div>
            </div>
        </div>


        <div class="h-table h-mrt30    bbbb" v-if="clickActive==1">
            <div class="h-pieceTitle2 hang">
                <h1 class="h1">订单详情</h1>
            </div>


            <el-table
                    ref="multipleTable"
                    @selection-change="handleSelectionChange"
                    :data="tableData2"
                    stripe
					border
                    style="width: 100%">
                <el-table-column
                        type="selection"
                        width="70"
                        label="全选">
                </el-table-column>
                <el-table-column
                        fixed
                        type="index"
                        label="序号"
                        width="50">
                </el-table-column>

                <el-table-column
                        prop="materialCode"
                        label="产品编码"
                        width="100%">
                </el-table-column>
                <el-table-column
                        prop="proModelCode"
                        label="产品型号"
                        width="100%">
                </el-table-column>
                <el-table-column
                        prop="proNumber"
                        label="订单数量"
                        width="90">
                </el-table-column>
                <el-table-column
                        prop="proBenchmarkPrice"
                        label="基准价"
                        width="80">
                </el-table-column>
                <el-table-column
                        prop="specialPrice"
                        label="特价"
                        width="70">
                </el-table-column>

                <el-table-column
                        prop="isStockUp"
                        label="是否备货"
                        width="80">
                    <template slot-scope="scope">
                        <dictname category="shifou_keyong"  :v="scope.row.isStockUp"/>
                    </template>
                </el-table-column>

                <el-table-column
                        prop="spare3"
                        label="定制需求"
                        width="100%">
                </el-table-column>

                <el-table-column
                        prop="extraPrice"
                        label="定制加价"
                        width="80">
                </el-table-column>

                <el-table-column
                        prop="finalPrice"
                        label="成交价"
                        width="80">
                </el-table-column>

                <el-table-column
                        prop="totalPrice"
                        label="总价"
                        width="100%">
                </el-table-column>

                <el-table-column
                        prop="spare1"
                        label="客户渠道"
						:show-overflow-tooltip="true"
                        width="100%">
                </el-table-column>

                <el-table-column
                        prop="contactName"
                        label="收货联系人"
						:show-overflow-tooltip="true"
                        width="100%">
                </el-table-column>
                <el-table-column
                        prop="toAddress"
                        label="收货地址"
						:show-overflow-tooltip="true"
                        width="200">
                </el-table-column>

                <el-table-column
                        label="预计收货日期"
                        class="h-elformWrap-2"
						:show-overflow-tooltip="true"
                        width="120"
                        prop="receivedTime">
                </el-table-column>
            </el-table>
        </div>

        <div class="jieguo">
            <span class="bizhong">币种</span>
            <span class="renminbi">{{ currencyCode }}</span>
            <span class="dingdan">订单总价</span>
            <span class="yuan">{{ allTotalPrice }}</span>
            <span class="xianjin">现金余额</span>
            <span class="money">{{ cashBalance }}</span>
            <span class="xianjin">现金占用</span>
            <span class="money">{{ cashOccupy }}</span>
            <span class="xianjin">信贷余额</span>
            <span class="zhangqi">{{ creditBalance }}</span>
            <span class="xianjin">信贷占用</span>
            <span class="zhangqi">{{ creditOccupy }}</span>
            <span class="jiazhi">净价值</span>
            <span class="make">￥5000</span>
        </div>


        <div class="h-table h-mrt30    bbbb" v-if="clickActive==1">
            <div class="h-pieceTitle2 hang">
                <h1 class="h1">审批意见</h1>
                <el-form :model="formLabelAlign" label-position="right" :inline="true"
                         class="demo-ruleForm h-formbLine inputO">
                    <el-form-item label="审批意见" class="h-elformWrap-2 " :required="flaag"
                                  style="margin:30px 0 20px 23px">
                        <el-input v-model="tableData.yijianMsg" placeholder="请输入"
                                  class="zidaoO"></el-input>
                    </el-form-item>
                </el-form>
                <div class="apprButton">
                    <el-row>
                        <el-button class="cancel" @click="cancel">取消</el-button>
                        <el-button class="refuse" @click="refuse">驳回</el-button>
                        <el-button class="pass" @click="pass">通过</el-button>
                    </el-row>
                </div>
            </div>
        </div>

        <!--        <el-dialog :visible.sync="dialogFormVisible2" class="h-dialog2">-->

        <!--            <div class="h-dialogImgwl">-->
        <!--                <div class="h-disTable">-->
        <!--                    <div class="h-tableCell">-->
        <!--                        <h1>提示信息</h1>-->
        <!--                        <p v-if="tishixinxi">{{tishixinxi}}</p>-->
        <!--                    </div>-->
        <!--                </div>-->
        <!--            </div>-->

        <!--        </el-dialog>-->

        <!--        <div class="F-H">-->
        <!--            <el-row>-->
        <!--                <el-button class="fanhui">返回</el-button>-->
        <!--            </el-row>-->
        <!--        </div>-->

    </div>
</template>
<style scoped>
    /* .xiangmu{
        margin-top: -23px;
    } */

    /*--------------- 审批样式 ----------------*/

    .redStar {
        position: absolute;
        top: 90%;
        left: 1%;
        color: red;
        font-size: 0.2rem;
    }

    .yijianbixutian {
        position: absolute;
        top: 1%;
        left: 15%;
        color: red;
    }


    .apprButton {
        margin-left: 6rem;
        margin-top: 30px;
    }

    .cancel {
        width: 18%;
    }

    .pass {
        background-color: #006aca;
        color: white;
        width: 18%;
    }

    .refuse {
        background-color: #24b5b8;
        color: white;
        width: 18%;
    }

    /*--------------- 审批样式 ------------------*/

    .rightstep {
        width: 170px;
        height: 5px;
        background-image: linear-gradient(-90deg,
        #0056a4 0%,
        #3291fd 100%),
        linear-gradient(
                #0e75e9,
                #0e75e9);
        background-blend-mode: normal,
        normal;
        position: relative;
    }

    .readiu {
        border-radius: 50%;
        width: 30px;
        height: 30px;
        border: 3px solid #0056a4;
        position: relative;
        left: 74px;
        top: -12px;
        background-color: white;
    }

    .fukaun {
        width: 170px;
        height: 5px;
        background-image: linear-gradient(-90deg,
        #e2e5e7 0%,
        #e2e5e7 100%),
        linear-gradient(
                #e2e5e7,
                #e2e5e7);
        background-blend-mode: normal,
        normal;
        position: relative;
    }

    .color {
        border-radius: 50%;
        width: 30px;
        height: 30px;
        border: 3px solid #c7c8ca;
        position: relative;
        left: 74px;
        top: -12px;
        background-color: white;
    }

    .fuwu {
        width: 48px;
        height: 50px;
        background-color: white;
        border-radius: 4px;
        border: solid 2px #c7c8ca;
        font-size: 15px;

        text-align: center;
        /* padding: 16px 0; */
        position: relative;
        flex-shrink: 0;
        margin: 20px 0;
    }

    .stepBox {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        align-items: center;
        margin-left: 3%;
    }

    .leftstep {
        width: 48px;
        height: 50px;
        background-color: #fcfcfc;
        border-radius: 4px;
        border: solid 2px #0e75e9;
        font-size: 15px;
        color: #0e75e9;
        text-align: center;
        /* padding: 16px 0; */
        position: relative;
        flex-shrink: 0;
        margin: 20px 0;

    }

    img {
        width: 18px;
        padding: 3px 0;
        margin-left: 0.035rem;
        /* margin-top: -3px; */
        color: block;
    }

    .name {
        margin-left: 9px;
        /* margin-top: -24px; */
    }

    .fanhui {
        padding: 15px 35px;
        color: white;
        background-color: #006aca;
    }

    .F-H {
        margin-top: 15px;
        margin-left: 8rem;
    }

    .icon {
        margin: 0 20px;
    }

    .stepBox {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        align-items: center;
        margin-left: 3%;
    }

    .stepBox .step {
        width: 16%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }

    .stepBox .step:last-child {
        width: 100px;
    }

    .stepBox .step .leftstep {
        width: 48px;
        height: 50px;
        background-color: #fcfcfc;
        border-radius: 4px;
        border: solid 2px #0e75e9;
        font-size: 15px;
        color: #0e75e9;
        text-align: center;
        /* padding: 16px 0; */
        position: relative;
        flex-shrink: 0;
        margin: 20px 0;

    }

    .stepBox .step .leftstep .times {
        width: 140px;
        position: absolute;
        top: 120px;

        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        color: #595959;
    }

    .stepBox .step .rightstep {
        width: 170px;
        height: 5px;
        background-image: linear-gradient(-90deg,
        #0056a4 0%,
        #3291fd 100%),
        linear-gradient(
                #0e75e9,
                #0e75e9);
        background-blend-mode: normal,
        normal;
        position: relative;
    }

    .stepBox .step .rightstep .circle {
        width: 23px;
        height: 23px;
        background-color: #fcfcfc;
        border: 2px solid #3291fd;
        overflow: hidden;
        border-radius: 50%;
        position: absolute;
        top: -9px;
        left: 63%;
        transform: translateX(-25px);
    }

    .stepBox .step .rightstep .circle img {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        width: 15px;
    }

    .make {
        width: 110px;
        padding-left: 17px;
    }

    .jiazhi {
        width: 100px;
        padding-left: 20px;
    }

    .zhangqi {
        width: 168px;
        padding-left: 10px;
    }

    .yuan, .zhanyong, .money, .xianjin, .dingdan {
        width: 120px;
        padding-left: 20px;
    }


    .renminbi {
        width: 90px;
        padding-left: 20px;
    }

    .bizhong {
        width: 72px;
        padding-left: 20px;

    }

    .renminbi,
    .money,
    .yuan,
    .zhangqi,
    .make {
        background-color: white;
        font-size: 10px;
    }

    .bizhong,
    .dingdan,
    .xianjin,
    .zhanyong,
    .jiazhi {
        background-color: #ebf5ff;
        font-size: 10px;
    }

    .bizhong,
    .renminbi,
    .dingdan,
    .money,
    .xianjin,
    .yuan,
    .zhangqi,
    .zhanyong,
    .jiazhi,
    .make {
        font-size: 15px;
        color: black;
        padding: 20px 0;
        padding-left: 18px;
        border-bottom: 1px solid rgb(223, 222, 222);
        border-right: 1px solid rgb(236, 236, 236);
    }

    .jieguo {
        margin-top: 12px;
        display: flex;
        margin: 0 20px;

    }

    /*span {*/
    /*    color: white;*/
    /*    position: relative;*/
    /*    top: -12px;*/
    /*    left: 20px;*/
    /*    font-size: 14px;*/
    /*}*/

    img {
        width: 25px;
        padding: 5px 0;
        margin-left: 8rem;
    }

    .newProject {
        margin: 0 20px;
        background-color: rgb(94, 182, 233);
    }

    .h-crumbOut {
        margin-bottom: 20px;
    }

    .h-piece {
        margin: 20px;
    }

    .h1 {
        margin-left: 27px;
    }

    .bbbb {
        padding-top: 5px;
        margin: 10px 20px 0 20px;
    }

    .neixiao .h-formbLine .h-elformWrap-2 {
        width: 33.333%;
    }

    .hang {
        padding: 20px 0;
        margin-bottom: 0;
        background-color: white;
    }
</style>
<style>
   /* .el-table__body .el-table__row .cell {
        padding: 0;
        height: 40px;
        line-height: 40px;
    } */

    .neixiao .h-formbLine .el-form-item__label {
        width: 43%;
    }

    .neixiao .h-formbLine .el-form-item__content {
        width: 57%;
    }

    /* .el-table__header .el-table-column--selection .cell .el-checkbox::after{
     content: "全选";
     color:white;
     background-color: rgb(93, 172, 236);
     font-size: 10px;
     } */


</style>

<script>
    import ss from '../../../api/SystemService'
    import big from 'big.js'

    export default {

        created() {
            this.q.orderId = this.$route.query.orderId || this.$route.query.ywid;
            this.q.taskid = this.$route.query.ywid;
            this.query();
            this.queryMoney();
        },
        mounted() {
        },

        methods: {
            hidden(index) {
                if (index === 6) {
                    this.show = fasle;
                }
            },

            //查询余额
            queryMoney() {
                ss.OrderService.queryMoney().then(rd => {
                    this.cashBalance = rd.obj.cashBalance;
                    this.creditBalance = rd.obj.creditBalance;
                });
            },

            //勾选事件
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },

            query() {
                ss.OrderService.getSingleOrderDetail(this.q).then(rd => {
                    console.log('订单详情', rd)
                    this.tableData2 = rd;

                    this.getETotalPrice(this.tableData2);

                    this.projectFname = this.tableData2[0].projectFname;
                    this.orderMainContract = this.tableData2[0].orderMainContract;
                    this.orderSubContract = this.tableData2[0].orderSubContract;

                    this.formInline.zCode = this.tableData2[0].zCode;
                    this.formInline.spare8 = this.tableData2[0].spare8;
                    this.formInline.orderCategory = this.tableData2[0].orderCategory;
                    this.formInline.disChannelCode = this.tableData2[0].disChannelCode;
                    this.currencyCode = this.tableData2[0].currencyCode;

                    if (this.formInline.disChannelCode == 'Z1') {
                        this.yincang = true;
                    }
                });
            },


            //计算每行总价
            getETotalPrice(x) {
                x.forEach((item, index) => {
                    item.totalPrice = new big(item.proNumber).times(item.finalPrice).toString();
                })
                this.tableData2 = x;
                this.getAllTotalPrice(this.tableData2);
            },

            //总价总和改变
            getAllTotalPrice(n) {
                n.allTotalPrice = 0;
                this.tableData2.forEach(function (val, index) {
                    n.allTotalPrice = new big(n.allTotalPrice).plus(val.totalPrice);
                })
                this.allTotalPrice = n.allTotalPrice.toString();
                this.showMeYourMoney();
            },
            //下单金额扣除
            showMeYourMoney() {
                this.cashOccupy = this.creditOccupy = 0;
                if (this.allTotalPrice <= this.cashBalance) {
                    //现金足够扣现金
                    this.cashOccupy = this.allTotalPrice;
                    //现金不足扣信贷
                } else if (this.allTotalPrice > this.cashBalance) {
                    //现金全部扣完
                    this.cashOccupy = this.cashBalance;
                    //剩余部分扣信贷
                    this.creditOccupy = this.allTotalPrice - this.cashBalance;
                }
            },

            //订单审核
            orderPass(x) {
                x.taskId = this.q.taskid;
                x.orderId = this.tableData2[0].orderId;
                ss.OrderService.orderPass(x).then(rd => {
                    console.log('审核流程结果', rd)
                });
                this.$router.push({path: '/thirdPage', query: {id: ''}});
            },

            //通过按钮
            pass() {
                // if(parseInt(this.tableData.orderStatus) < 24){
                //     this.tableData.orderStatus = (parseInt(this.tableData.orderStatus) + 1).toString();
                // }
                if (this._user.usercode == 'A00207') {
                    this.tableData.orderStatus = 21;
                } else if (this._user.usercode == 'A00221') {
                    this.tableData.orderStatus = 24;
                } else if (this._user.usercode == 'A0001668') {
                    this.tableData.orderStatus = 20;
                }
                this.tableData.aaa = 2
                this.tableData.optflag = '审核通过';
                this.orderPass(this.tableData);
            },

            //驳回按钮
            refuse() {
                if (this.tableData.yijianMsg.msg == '') {
                    this.$msg.msge('驳回必须输入审批意见!');
                } else {
                    if (this._user.usercode == 'A00207') {
                        this.tableData.orderStatus = 22;
                    } else if (this._user.usercode == 'A00221') {
                        this.tableData.orderStatus = 23;
                    }
                    this.tableData.aaa = 1
                    this.tableData.optflag = '审核被驳回';
                    this.orderPass(this.tableData);
                }


            },

            //取消按钮
            cancel() {
                //返回首页
                this.$router.push({path: '/', query: {id: ''}});
            },
        },
        data() {
            return {

                //订单审核相关数据
                tableData: {
                    orderStatus: '',
                    orderId: '',
                    optflag: '',
                    yijianMsg: '',
                    aaa: '',
                    taskId: '',
                },

                yincang: false,

                projectFname: '',
                orderMainContract: '',
                orderSubContract: '',

                flaag: true,
                //表单
                q: {
                    taskid: null,
                    orderId: '',
                },

                //现金及信贷
                cashBalance: 0,
                cashOccupy: 0,
                creditBalance: 0,
                creditOccupy: 0,
                allTotalPrice: 0,
                currencyCode: '',

                //审批意见
                approOpinion: '',
                //审批提示信息
                tishixinxi: '',
                yijianbixutian: false,
                tejiashenpi: {

                    shenheyijian: '',

                },
                show: true,

                formInline: {
                    spare8: '',
                    orderCategory: '',
                    disChannelCode: '',
                    zCode: '',
                },
                message: '',
                value1: '',
                multipleSelection: [],
                tableData2: [],
                clickActive: 1,
                formLabelAlign: {},

            };
        },
    }

</script>


